export default "__VITE_ASSET__DqGqefWx__"